import { render } from "./login.vue?vue&type=template&id=378ed9db&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=378ed9db&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378ed9db"]])

export default __exports__